class AnnouncementBar extends HTMLElement {
  static dismissedKey = 'announcement-bar-dismissed';

  connectedCallback() {
    this.closeButton = this.querySelector('[data-announcement-bar-close]');
    this.closeButton?.addEventListener('click', this.dismiss.bind(this));
  }

  dismiss() {
    this.hidden = true;

    try {
      sessionStorage.setItem(AnnouncementBar.dismissedKey, 'true');
    } catch (error) {
      // Storage can throw in private-browsing/locked-down contexts — the
      // bar still hides for this page view either way, it just won't stay
      // dismissed on the next one.
    }

    // site-header.js already recalculates --announcement-bar-height (and
    // everything positioned relative to it) on window resize, so reuse
    // that instead of duplicating its measurement logic here.
    window.dispatchEvent(new Event('resize'));
  }
}

customElements.define('announcement-bar', AnnouncementBar);
